import { render } from "./OfferTable.vue?vue&type=template&id=50a29940"
import script from "./OfferTable.vue?vue&type=script&lang=js"
export * from "./OfferTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__